import React from "react";
import { Typography, Container, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import "./Style.css";
import HeroImage from "../assets/Hero5.webp";

// Hero container with background image
const HeroContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  textAlign: "center",
  backgroundImage: `url("${HeroImage}")`,
  backgroundPosition: "center",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  color: "white",
  padding: "20px",
  position: "relative",
});

// Overlay to replace &::before
const Overlay = styled(Box)({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 51, 34, 0.6)",
});

// Content wrapper to keep content above overlay
const ContentWrapper = styled(Container)({
  position: "relative",
  zIndex: 1,
  maxWidth: "800px",
});

function HeroSection() {
  return (
    <HeroContainer id="Hero">
      <Overlay /> {/* Semi-transparent overlay */}
      <ContentWrapper>
        <Typography variant="h2" className="hero-title" gutterBottom>
          Explore the World with Us
        </Typography>
        <Typography variant="h6" className="hero-subtitle" gutterBottom>
          Discover breathtaking destinations and unforgettable experiences.
        </Typography>
      </ContentWrapper>
    </HeroContainer>
  );
}

export default HeroSection;
